import { render, staticRenderFns } from "./goodsDetailsTpl2.vue?vue&type=template&id=4e9f843c&scoped=true"
import script from "./goodsDetailsTpl2.vue?vue&type=script&lang=js"
export * from "./goodsDetailsTpl2.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailsTpl2.vue?vue&type=style&index=0&id=4e9f843c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f843c",
  null
  
)

export default component.exports